<template minapp='mpx' xlang='wxml'>
  <view class="scramble-contact-person-wrap">
    <view wx:for="{{passengers}}" class="item">
      <view class="name">{{item.passenger_name}}</view>
      <view class="id">{{item.passenger_id_type_name}} {{ item.passenger_id_no }}</view>
      <view class="line"></view>
    </view>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  import { innerRouter, pagePath } from '@/common/jump'
  import store from '@/store'

  createComponent({
    props: { orderList: [] },
    computed: {
      ...store.mapState({
        scramble_ticket_info: 'order.scramble_ticket_info'
      }),
      passengers(){
        return this.scramble_ticket_info?.passengers
      }
    },
    methods: {
    }
  })
</script>
<style scoped lang="stylus">
  @import '~@/mixins/stylus/color.styl'
  .scramble-contact-person-wrap
    background #FFFFFF
    border-radius 8px
    margin-bottom 8px
    .item
      padding 16px 11px
      position relative
      .name
        font-family PingFangSC-Medium
        font-size 16px
        font-weight normal
        line-height 16px
        letter-spacing 0px
        color #000000
        margin-bottom 8px
      .id
        font-family PingFangSC-Regular
        font-size 14px
        font-weight normal
        line-height 14px
        letter-spacing 0px
        color #999999
      .line
        position absolute
        bottom 0
        left 12px
        width calc(100% - 24px)
        height 0.5px
        background #F0F1F4


</style>
<script name='json'>
  module.exports = {
    component: true
  }
</script>